module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/406.9413ee00.png";